<!-- =========================================================================================
  File Name: Slider.vue
  Description: Slider slider Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card class="mb-2">

      <div slot="no-body" class="tabs-container pl-6 py-3">
        <div class="w-full vx-row mb-2">
          <div class="vx-col w-3/12">
            <ejs-textbox floatLabelType="Auto" placeholder="Nombre" :enabled="editing" v-model="data_local.name"/>
          </div>
          <div class="flex vx-col w-9/12 items-center justify-end h-full">
            <div class="flex items-center justify-center w-48 h-12 mr-px rounded-sm bg-primary text-white cursor-pointer" @click="save" v-if="editing">
              <vs-icon icon-pack="feather" icon="icon-save" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Guardar cambios</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm border border-solid border-warning cursor-pointer" @click="reset_data" v-if="editing">
              <vs-icon icon-pack="feather" icon="icon-corner-up-left" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Cancelar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 mr-px rounded-sm bg-primary text-white cursor-pointer" @click="editing = true" v-if="!editing">
              <vs-icon icon-pack="feather" icon="icon-edit-2" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Editar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm bg-danger text-white cursor-pointer" @click="confirmDeleteRecord" v-if="!editing">
              <vs-icon icon-pack="feather" icon="icon-x" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Eliminar</div>
            </div>
          </div>
        </div>
        <div class="w-full vx-row">
          <div class="vx-col w-full">
            <ejs-textbox floatLabelType="Auto" placeholder="Descripción" :multiline="true" :enabled="editing" v-model="data_local.description"/>
          </div>
        </div>
        <div class="w-full vx-row">
          <div class="vx-col w-2/12">
            <ejs-numerictextbox floatLabelType="Auto" placeholder="Precio" format="N2" :enabled="editing" textAlign='Right' v-model="data_local.price" :min="0" :showSpinButton="false" :step="0.01"/>
          </div>
          <div class="vx-col w-10/12">
            <ejs-dropdownlist
              ref="product"
              floatLabelType="Auto"
              placeholder="Producto"
              highlight=true
              v-model="data_local.productId"
              :dataSource="products"
              :fields="{text: 'searchField', value: 'id'}"
              allowFiltering=true
              :filtering='productFiltering'
              :enabled="editing"
            />
          </div>
        </div>
        <div class="w-full vx-row">
          <div class="vx-col w-2/12">
            <ejs-numerictextbox floatLabelType="Auto" placeholder="Secuencia" format="N0" :enabled="editing" textAlign='Right' v-model="data_local.sequence"/>
          </div>
          <div class="vx-col w-1/3">
            <ejs-dropdownlist floatLabelType="Auto" placeholder="Estado" highlight=true :dataSource="status" :fields="{text: 'value', value: 'id'}" v-model="data_local.status" :enabled="editing"></ejs-dropdownlist>
          </div>
        </div>

        <div class="w-full flex flex-col mt-4 p-2">
          <h5>Imagen: {{ data_local.imageURL }}</h5>
          <div
            class="flex w-full my-4 block bg-contain bg-no-repeat bg-center items-end justify-between border border-dotted border-primary"
            :style="{ 'background-image': `url(${previewImage})`}"
            style="height: 400px; background-repeat: no-repeat; background-position: center center;"
          >
            <input
              ref="fileInput"
              type="file"
              accept="image/*"
              @input="pickFile"
              class="opacity-0 absolute"
            />
            <vs-button class="ml-2 mb-2" color="success" icon-pack="feather" icon="icon-image" @click="selectImage" v-if="editing">Seleccionar</vs-button>
            <vs-button class="mr-2 mb-2" color="danger" icon-pack="feather" icon="icon-x" @click="previewImage = null" v-if="editing">Eliminar</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
  import Vue from "vue";
  import {Query} from "@syncfusion/ej2-data";
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {NumericTextBoxPlugin} from "@syncfusion/ej2-vue-inputs";
  import {CheckBoxPlugin} from "@syncfusion/ej2-vue-buttons";
  import {DropDownListPlugin, MultiSelectPlugin} from "@syncfusion/ej2-vue-dropdowns";
  import {firebase, db, storage} from '@/firebaseConfig';

  Vue.use(TextBoxPlugin);
  Vue.use(NumericTextBoxPlugin);
  Vue.use(CheckBoxPlugin);
  Vue.use(DropDownListPlugin);
  Vue.use(MultiSelectPlugin);

  export default {
    data() {
      return {
        loaded: false,
        editing: false,
        id: 0,
        data: null,
        status: [{id: 'ACT', value: 'Activo'}, {id: 'IN', value: 'Inactivo'}],
        imageChanged: false,
        data_local: {
          id: 0,
          name: '',
          description: '',
          productId: '',
          price: 0.0
        },
        id_not_found: false,
        currentStatus: 0,
        uploadFieldName: 'photos',
        previewImage: null,
        productQuery: new Query().select(['searchField', 'id']).take(10)
      }
    },
    computed: {
      imagesURL() {
        return this.$store.getters['getParameter']('images').baseURL;
      },
      products() {
        return this.$store.getters.productsList;
      },
      image() {
        return [this.imagesURL, '/slider%2F', this.data_local.imageURL.split('.')[0], '@400.', this.data_local.imageURL.split('.')[1], '?alt=media'].join('');
      }
    },
    methods: {
      reset_data() {
        if (this.id > 0) {
          this.editing = false;
          this.imageChanged = false;
          this.data_local = JSON.parse(JSON.stringify(this.data));
          this.data_local.productId = parseInt(this.data.productId);
          /*
                    if (this.$refs.product) {
                      const productId = this.$store.getters.getProduct(this.data_local.productId);
                      if (productId) {
                        this.$refs.product.ej2Instances.value = productId.id;
                        this.$refs.product.ej2Instances.text = `${productId.isbn} | ${productId.name}`;
                      }
                    }
          */
          this.previewImage = this.image;
          this.loaded = true;
        } else {
          this.$router.push({name: 'sliders'});
        }
      },
      productFiltering: function (e) {
        const searchData = JSON.parse(JSON.stringify(this.products));
        if (e.text == '') {
          e.updateData(searchData);
        } else {
          let query = new Query().select(['searchField', 'id']);
          query = (e.text !== '') ? query.where('searchField', 'contains', e.text, true, true) : query;
          e.updateData(searchData, query);
        }
      },
      selectImage() {
        this.$refs.fileInput.click();
      },
      pickFile() {
        const input = this.$refs.fileInput;
        const file = input.files;
        if (file && file[0]) {
          const reader = new FileReader;
          reader.onload = e => {
            this.previewImage = e.target.result;
          };
          reader.readAsDataURL(file[0]);
          this.$emit('input', file[0]);
        }
      },
      getData(id) {
        if (id) {
          if (id == 0) {
            this.$vs.loading.close();
            this.loaded = true;
            this.id_not_found = false;
            this.editing = true;
          } else {
            this.data = this.$store.getters.getSlider(id);
            this.reset_data();
          }
        } else {
          this.$vs.loading.close();
          this.loaded = true;
          if (id == 0) {
            this.id_not_found = false;
          }
          this.editing = true;
        }
      },
      validateForm() {
        let message = '';
        if (this.data_local.status.trim() == '') {
          message = `${message}${(message == '' ? '' : '<br/>')}Debe seleccionar una estado`
        }
        if (message != '') {
          this.$vs.notify({
            title: 'Error validando información',
            text: message,
            color: 'danger'
          });
        }
        return (message == '');
      },
      updateImage(imageFile, newId) {
        const self = this;
        const imageRef = storage.ref().child(`slider/${imageFile.name}`);
        imageRef.put(imageFile)
          .then(() => {
            self.$vs.notify({
              title: 'Información actualizada',
              text: 'Datos del elemento de carrusel fueron actualizados correctamente',
              color: 'primary'
            });
            if (self.id == 0) {
              self.$router.push({name: 'slider', params: {id: newId}});
            }
            self.editing = false;
          })
          .catch((error) => {
            self.$vs.notify({
              title: 'ADVERTENCIA',
              text: `Datos del elemento de carrusel fueron actualizados correctamente pero ocurrió un error al actualizar imagen: ${error.message}`,
              color: 'warning'
            });
          });
        self.$vs.loading.close();
      },
      updateList(list, newId) {
        const self = this;
        db.collection('home').doc('sliderProducts').update({list: list})
          .then(() => {
            if (self.$refs.fileInput.files.length > 0) {
              self.updateImage(self.$refs.fileInput.files[0], newId);
            } else {
              self.$vs.notify({
                title: 'Información actualizada',
                text: 'Datos del elemento de carrusel fueron actualizados correctamente',
                color: 'primary'
              });
              if (self.id == 0) {
                self.$router.push({name: 'slider', params: {id: newId}});
              }
              self.editing = false;
              self.$vs.loading.close();
            }
          })
          .catch((error) => {
            self.$vs.notify({
              title: 'Error al actualizar',
              text: error.message,
              color: 'danger'
            });
            self.$vs.loading.close();
          })
      },
      save() {
        if (this.validateForm()) {
          this.$vs.loading({
            text: 'Guardando información de elemento de carrusel ',
            type: 'point'
          });
          if (this.$refs.fileInput.files.length > 0) {
            this.data_local.imageURL = this.$refs.fileInput.files[0].name;
          }
          this.data_local.statusName = this.data_local.status == 'ACT' ? 'Activo' : 'Inactivo';
          const list = [...this.$store.getters.slidersList];
          if (this.data_local.id > 0) {
            const index = list.findIndex(i => i.id === this.data_local.id);
            if (index >= 0) {
              list[index] = JSON.parse(JSON.stringify(this.data_local));
              this.updateList(list, this.data_local.id);
            }
          } else {
            const self = this;
            db.collection('home').doc('sliderProducts').update({sequence: firebase.firestore.FieldValue.increment(1)})
              .then(() => {
                const data = {...this.data_local};
                db.collection('home').doc('sliderProducts').get()
                  .then(doc => {
                    if (doc.exists) {
                      const newId = doc.data();
                      data.id = newId.sequence;
                      list.push(data);
                      self.updateList(list, data.id);
                    }
                  })
                  .catch((error) => {
                    self.$vs.notify({
                      title: 'Error al obtener secuencia',
                      text: error.message,
                      color: 'danger'
                    });
                    self.$vs.loading.close();
                  });
              })
              .catch((error) => {
                self.$vs.notify({
                  title: 'Error al actualizar',
                  text: error.message,
                  color: 'danger'
                });
                self.$vs.loading.close();
              });
          }
        }
      },
      confirmDeleteRecord() {
        console.log('Delete');
        console.log(this.data_local.productId);
        console.log(this.$refs.product.ej2Instances.value);
      }
    },

    mounted() {
      this.id = parseInt(this.$route.params.id);
      const self = this;
      setTimeout(function () {
        self.getData(self.id);
      }, 750);
    }
  }
</script>

<style lang="scss">
  @import '../../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';*/
  @import '../../../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
  @import '../../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  /*@import '../../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-popups/styles/material.css';*/
  /*@import '../../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  /*@import "../../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
</style>
